// extracted by mini-css-extract-plugin
export default {"card":"Thanks_card__e0gJ8","image":"Thanks_image__EUlWI","rating":"Thanks_rating__CkYs9","title":"Thanks_title__mP2sJ","subtitle":"Thanks_subtitle__VMkgs"};